import React from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import EntityForm from '../../../../components/form/base/EntityForm';
import { MultimediaValues } from '../../model/multimediaModel';
import Title from '../../../../components/Title';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import { BreadcrumbsLinkData } from '../../../../components/Breadcrumbs/model/breadcrumbsModel';
import Upload from '../../../../components/form/elements/Upload';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../../components/form/enum/formProps';
import TextField from '../../../../components/form/elements/TextField';

interface MultimediaFormProps {
  title: string;
  breadcrumbs: BreadcrumbsLinkData[];
  initialValues: MultimediaValues;
  onSubmit: (values: MultimediaValues) => void;
}

const validationSchema = Yup.object().shape({
  file: Yup.mixed().required('validation.is_required'),
  name: Yup.string().min(2, 'validation.too_short').max(120, 'validation.too_long'),
});

const MultimediaForm: React.FC<MultimediaFormProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Title>{t(props.title)}</Title>
      <Breadcrumbs title={props.title} links={props.breadcrumbs} hide />
      <EntityForm<MultimediaValues>
        initialValues={props.initialValues}
        validationSchema={validationSchema}
        onSubmit={props.onSubmit}
      >
        <TextField
          name="name"
          label="multimedia.name"
          type={TEXT_FIELD_TYPE.TEXT}
          color={TEXT_FIELD_COLOR.PRIMARY}
          variant={TEXT_FIELD_VARIANT.STANDARD}
        />
        {props.initialValues.file ? (
          <TextField
            name="file"
            label="multimedia.file"
            type={TEXT_FIELD_TYPE.TEXT}
            color={TEXT_FIELD_COLOR.PRIMARY}
            variant={TEXT_FIELD_VARIANT.STANDARD}
            disabled
          />
        ) : (
          <Upload name="file" label="multimedia.file" color={TEXT_FIELD_COLOR.PRIMARY} />
        )}
      </EntityForm>
    </>
  );
};

export default MultimediaForm;
